import { render, staticRenderFns } from "./ChatGroupJoinGroup.vue?vue&type=template&id=f6f216f8&scoped=true&lang=pug"
import script from "./ChatGroupJoinGroup.vue?vue&type=script&lang=js"
export * from "./ChatGroupJoinGroup.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupJoinGroup.vue?vue&type=style&index=0&id=f6f216f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f216f8",
  null
  
)

export default component.exports